package ui.login

import androidx.compose.runtime.*
import provider.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import ui.*

interface LoginScope {

    val vm: LoginVM
    val nav: Navigation
    val args: ArgsInitial
    val accountProvider: CommonAccountProvider
    val action: (LoginVM.Action) -> Unit

    companion object {
        @Composable
        fun rememberScope(): LoginScope {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(LoginVM::class)
            val acc = LocalAccountProvider.current
            val args = LocalNavigationArgs.current.args<ArgsInitial>()
            val action = LoginVM.Action.rememberAction(vm)
            return remember {
                object : LoginScope {
                    override val vm: LoginVM
                        get() = vm
                    override val nav: Navigation
                        get() = nav
                    override val args: ArgsInitial
                        get() = args
                    override val accountProvider: CommonAccountProvider
                        get() = acc
                    override val action: (LoginVM.Action) -> Unit
                        get() = action


                }.also {
                    vm.init(it)
                }
            }
        }
    }
}
